import { styledComponent, Grid, Typography, Paper, Box, Divider } from '@hermes/web-components'
import Avatar from '../../../Avatar'

const transitionDuration = '0.1s linear'

export const SearchProfileCardContainer = styledComponent(Grid)(({ theme }) => ({
  border: `1px solid ${theme.palette.blue[200]}`,
  borderRadius: '16px',
  transition: transitionDuration,
  backgroundColor: 'white',
  width: '100%',
  wrap: 'nowrap',
  gap: '16px',
  maxHeight: '100%',
  minHeight: '385px',
  height: '100%',
  cursor: 'pointer',
  '&:hover': {
    border: `1px solid ${theme.palette.blue['400']}`,
    hr: {
      backgroundColor: theme.palette.blue['400']
    },
    '.rate-paper-container': {
      borderColor: theme.palette.blue['400']
    }
  }
}))

export const SearchProfileCardContent = styledComponent(Box)({
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  display: 'grid',
  width: '100%',
  gridTemplateRows: 'auto 1fr'
})

export const StyledDivider = styledComponent(Divider)(({ theme }) => ({
  border: 'none',
  backgroundColor: theme.palette.blue[200],
  height: '1px',
  minWidth: '100%',
  transition: transitionDuration
}))

export const NameTypography = styledComponent(Typography)<{
  component: string
}>({
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '26px',
  paddingRight: '24px',
  display: 'inline'
})

export const SponsoredBanner = styledComponent(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.light3,
  padding: '2px 8px',
  borderRadius: '6px',
  fontWeight: 400,
  fontSize: '13px',
  position: 'absolute',
  top: '-35px',
  display: 'flex',
  alignItems: 'center',
  gap: '5px'
}))

export const TopKeywordText = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: 500,
  fontSize: '15px',
  lineHeight: '20px',
  color: theme.palette.text.darkNavy
}))

export const StyledAvatar = styledComponent(Avatar)(({ theme }) => ({
  width: '82px',
  height: '82px',
  ...(theme?.custom?.SearchProfileCard?.avatar ?? {})
}))

export const StyledPaper = styledComponent(Paper, {
  shouldForwardProp: (prop: string) => !['isProfileReviewsPresent'].includes(prop)
})<{ isProfileReviewsPresent?: boolean }>(({ isProfileReviewsPresent, theme }) => ({
  width: '100%',
  cursor: isProfileReviewsPresent ? 'pointer' : 'auto',
  marginBottom: 0,
  paddingBottom: theme.spacing(2),
  backgroundColor: 'transparent',
  boxShadow: 'none',
  height: '100%',
  paddingTop: '12px',
  borderRadius: 0,
  borderTop: `1px solid ${theme.palette.background.searchCardPaper}`,
  transition: transitionDuration
}))

export const RatePaperMobileTypography = styledComponent(Typography)(({ theme }) => ({
  ...theme.custom.SearchProfileCard.mobile.subtitleText,
  width: '100%',
  lineHeight: '20px'
}))

export const StyledGridForPaper = styledComponent(Grid)({
  padding: '0 20px',
  borderLeft: 'none',
  height: '100%',
  minHeight: '267px'
})
